import React from "react";
import { Link } from "gatsby";

import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

import BlogRollHome from "../components/BlogRollHome";
import BlogRollHomeMain from "./BlogRollHomeMain";

const LatestJobs = class extends React.Component {
  render() {
    return (
      <section className="latest">
        <InView threshold={0.2}>
          {({ ref, inView }) => (
            <motion.div
              class="marquee-latest banner"
              ref={ref}
              initial={{ opacity: 0 }}
              animate={inView ? { opacity: 1 } : { opacity: 0 }}
              transition={{
                delay: 0.25,
              }}
            >
              <div class="track">
                <div class="content">
                  <h2>&nbsp;latest jobs latest jobs latest jobs latest jobs latest jobs latest jobs </h2>
                </div>
              </div>
            </motion.div>
          )}
        </InView>
        <BlogRollHome />
        <BlogRollHomeMain />
      </section>
    );
  }
};

export default LatestJobs;
